<template>
  <div>
    <Loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :opacity="0.5"
      loader="dots"
    ></Loading>
    <!-- Modal Add Financial Note -->
    <SuccessDialog :msg="successMessage" v-show="showSuccess"></SuccessDialog>
    <b-modal
      id="addFinancialNote"
      title="BootstrapVue"
      hide-header-close
      hide-footer
      hide-header
      centered
    >
      <b-form-group>
        <h3 style="text-align: center">
          {{ $t("depreciation.add_category_sub_financial_note") }}
        </h3></b-form-group
      >
      <b-row>
        <form @submit.prevent="addSubNoteAcc">
          <b-form-group>
            <b-col cols="12 mt-2">
              <b-input-group>
                <p>
                  {{ $t("depreciation.code_asset") }}
                </p>
                <b-form-input
                  v-model="code_asset"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group>
                <p>
                  {{ $t("depreciation.name_asset") }}
                </p>
                <b-form-input
                  v-model="name_asset"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12 mt-2">
              <b-input-group>
                <p>
                  {{ $t("depreciation.code_acc") }}
                </p>
                <b-form-input
                  v-model="code_acc"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group>
                <p>
                  {{ $t("depreciation.name_acc") }}
                </p>
                <b-form-input
                  v-model="name_acc"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12 mt-2">
              <b-input-group>
                <p>
                  {{ $t("depreciation.code_acc_dp") }}
                </p>
                <b-form-input
                  v-model="code_acc_dp"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group>
                <p>
                  {{ $t("depreciation.name_acc_dp") }}
                </p>
                <b-form-input
                  v-model="name_acc_dp"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <div class="row flex justify-content-center text-center">
                <button
                  type="button"
                  class="cancel-button"
                  data-dismiss="modal"
                  @click="$bvModal.hide('addFinancialNote')"
                >
                  {{ $t("btn.canc") }}
                </button>
                <button
                  type="submit"
                  class="col confirm-button"
                  data-dismiss="modal"
                >
                  {{ $t("btn.save") }}
                </button>
              </div>
            </b-col>
          </b-form-group>
        </form>
      </b-row>
    </b-modal>
    <!-- Modal Edit Financial Note -->
    <b-modal
      id="editFinancialNote"
      title="BootstrapVue"
      hide-header-close
      hide-footer
      hide-header
      centered
    >
      <b-form-group>
        <h3 style="text-align: center">
          {{ $t("depreciation.manage_category_sub_financial_note") }}
        </h3></b-form-group
      >
      <b-row>
        <form @submit.prevent="updateSubNoteAcc">
          <b-form-group>
            <b-col cols="12 mt-2">
              <b-input-group>
                <p>
                  {{ $t("depreciation.code_asset") }}
                </p>
                <b-form-input
                  v-model="code_asset"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group>
                <p>
                  {{ $t("depreciation.name_asset") }}
                </p>
                <b-form-input
                  v-model="name_asset"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12 mt-2">
              <b-input-group>
                <p>
                  {{ $t("depreciation.code_acc") }}
                </p>
                <b-form-input
                  v-model="code_acc"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group>
                <p>
                  {{ $t("depreciation.name_acc") }}
                </p>
                <b-form-input
                  v-model="name_acc"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12 mt-2">
              <b-input-group>
                <p>
                  {{ $t("depreciation.code_acc_dp") }}
                </p>
                <b-form-input
                  v-model="code_acc_dp"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-input-group>
                <p>
                  {{ $t("depreciation.name_acc_dp") }}
                </p>
                <b-form-input
                  v-model="name_acc_dp"
                  class="w-full"
                  required
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <div class="row flex justify-content-center text-center">
                <button
                  type="button"
                  class="cancel-button"
                  data-dismiss="modal"
                  @click="$bvModal.hide('editFinancialNote')"
                >
                  {{ $t("btn.canc") }}
                </button>
                <button
                  type="submit"
                  class="col confirm-button"
                  data-dismiss="modal"
                >
                  {{ $t("btn.save") }}
                </button>
              </div>
            </b-col>
          </b-form-group>
        </form>
      </b-row>
    </b-modal>
    <!-- Modal Delete -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div
          class="modal-content container-fluid pt-4 pb-2"
          style="border-radius: 10px"
        >
          <div class="row">
            <img class="del-icon mb-3" src="../../assets/delete_bin.svg" />
            <p class="mb-3">
              {{ $t("depreciation.click_todel_sub") }}
            </p>
          </div>
          <div class="row flex justify-content-center text-center">
            <button type="button" class="cancel-button" data-dismiss="modal">
              {{ $t("btn.canc") }}
            </button>
            <button
              type="button"
              class="confirm-button confirm-button-red"
              data-dismiss="modal"
              @click="confirmDelete()"
            >
              {{ $t("btn.conf") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="manage-accounting my-3" style="padding: 0.4em">
      <div class="main">
        <p class="note-acc-name">{{ noteAccountingSelect.name }}</p>
        <div
          class="menu d-flex flex-wrap align-items-center justify-content-between my-3"
        >
          <div class="d-flex align-items-center flex-wrap">
            <button
              class="d-flex filter text-light p-2 m-0"
              style="border: none"
              type="button"
              @click="openModalAddFinancialNote"
            >
              + {{ $t("depreciation.add_sub_note_accountings") }}
            </button>
          </div>
          <!-- <div class="search-box d-flex" style="border-radius: 10px;">
            <img src="@/assets/search-white.svg" width="20px" />
            <input
              type="text"
              :placeholder="$t('home.search')"
              v-model="searchText"
            />
          </div> -->
        </div>
        <ManageSubFinancialNoteTable ref="userTable" :searchText="searchText" />
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import { authHeader } from "../../store/actions";
import Loading from "vue-loading-overlay";
import moment from "moment";
import ManageSubFinancialNoteTable from "../../components/Table/Depreciation/ManageSubFinancialNoteTable.vue";
import SuccessDialog from "@/components/SuccessDialog.vue";
import { mapGetters } from "vuex";
import baseUrl from "../../util/backend";
export default {
  name: "DepreciationAsset",
  components: {
    ManageSubFinancialNoteTable,
    Loading,
    SuccessDialog,
  },
  data() {
    return {
      isLoading: true,
      company_id: null,
      searchText: "",
      code_asset: "",
      name_asset: "",
      code_acc: "",
      name_acc: "",
      code_acc_dp: "",
      name_acc_dp: "",
      successMessage: "",
      showSuccess: false,
      update_sub_note_accounting_id: "",
      del_sub_note_accounting_id: "",
    };
  },
  filters: {
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
  },
  computed: {
    ...mapGetters({
      companyName: "companyName",
      noteAccountingSelect: "noteAccountingSelect",
    }),
  },
  methods: {
    async openModalAddFinancialNote() {
      this.code_asset = "";
      this.name_asset = "";
      this.code_acc = "";
      this.name_acc = "";
      this.code_acc_dp = "";
      this.name_acc_dp = "";
      await this.$bvModal.show("addFinancialNote");
    },
    async addSubNoteAcc() {
      this.isLoading = true;
      const id_company = await this.$store.dispatch("getCompanyIdCookie");
      this.code_asset = this.code_asset.trim();
      this.name_asset = this.name_asset.trim();
      this.code_acc = this.code_acc.trim();
      this.name_acc = this.name_acc.trim();
      this.code_acc_dp = this.code_acc_dp.trim();
      this.name_acc_dp = this.name_acc_dp.trim();
      if (this.name_acc && this.code_acc) {
        let data = {
          code_asset: this.code_asset,
          name_asset: this.name_asset,
          code_acc: this.code_acc,
          name_acc: this.name_acc,
          code_acc_dp: this.code_acc_dp,
          name_acc_dp: this.name_acc_dp,
          note_accounting_id: this.$route.params.note_accounting_id,
          id_company: id_company,
        };
        try {
          await this.$store.dispatch("addSubNoteAcc", data);
          this.successMessage = this.$t("dialog.add_success");
          this.showSuccess = true;
          setTimeout(() => {
            this.showSuccess = false;
          }, 2000);
        } catch (e) {
          if (e.response) {
            if (
              e.response.data.message == "Already in use by another"
            ) {
              Swal.fire({
                icon: "error",
                title: this.$t("dialog.error"),
                text: this.$t("depreciation.err_sub_note_acc"),
                timer: 2000,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: this.$t("dialog.error"),
                showConfirmButton: false,
                timer: 2000,
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: this.$t("dialog.error"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
        this.$store.dispatch(
          "getNoteAccounting",
          this.$route.params.note_accounting_id
        );
        this.$bvModal.hide("addFinancialNote");
      }
      this.isLoading = false;
    },
    async setEditNoteAcc(sub_note_accounting_id) {
      this.update_sub_note_accounting_id = sub_note_accounting_id;
      const sub_note_accounting = this.noteAccountingSelect.sub_note_accountings.find(
        (subNoteAcc) =>
          subNoteAcc.sub_note_accounting_id ==
          this.update_sub_note_accounting_id
      );
      this.code_asset = sub_note_accounting.code_asset;
      this.name_asset = sub_note_accounting.name_asset;
      this.code_acc = sub_note_accounting.code_acc;
      this.name_acc = sub_note_accounting.name_acc;
      this.code_acc_dp = sub_note_accounting.code_acc_dp;
      this.name_acc_dp = sub_note_accounting.name_acc_dp;
    },
    async updateSubNoteAcc() {
      this.isLoading = true;
      const id_company = await this.$store.dispatch("getCompanyIdCookie");
      this.code_asset = this.code_asset.trim();
      this.name_asset = this.name_asset.trim();
      this.code_acc = this.code_acc.trim();
      this.name_acc = this.name_acc.trim();
      this.code_acc_dp = this.code_acc_dp.trim();
      this.name_acc_dp = this.name_acc_dp.trim();
      if (this.name_acc && this.code_acc) {
        let data = {
          code_asset: this.code_asset,
          name_asset: this.name_asset,
          code_acc: this.code_acc,
          name_acc: this.name_acc,
          code_acc_dp: this.code_acc_dp,
          name_acc_dp: this.name_acc_dp,
          sub_note_accounting_id: this.update_sub_note_accounting_id,
          id_company: id_company,
        };
        try {
          await this.$store.dispatch("updateSubNoteAcc", data);
          this.successMessage = this.$t("dialog.save_edit");
          this.showSuccess = true;
          setTimeout(() => {
            this.showSuccess = false;
          }, 2000);
        } catch (e) {
          if (e.response) {
            if (e.response.data.message == "Already in use by another") {
              this.isLoading = false;
              return Swal.fire({
                icon: "error",
                title: this.$t("dialog.error"),
                text: this.$t("depreciation.err_sub_note_acc"),
                timer: 2000,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: this.$t("dialog.error"),
                showConfirmButton: false,
                timer: 2000,
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: this.$t("dialog.error"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
        this.$store.dispatch(
          "getNoteAccounting",
          this.$route.params.note_accounting_id
        );
        this.$bvModal.hide("editFinancialNote");
      }
      this.isLoading = false;
    },
    showDelete(subNoteAccounting) {
      this.del_sub_note_accounting_id =
        subNoteAccounting.sub_note_accounting_id;
    },
    async confirmDelete() {
      const id_company = await this.$store.dispatch("getCompanyIdCookie");
      try {
        await this.$store.dispatch("deleteSubNoteAcc", {
          id_company: id_company,
          sub_note_accounting_id: this.del_sub_note_accounting_id,
        });
        this.successMessage = this.$t("dialog.delete_success");
        this.showSuccess = true;
        setTimeout(() => {
          this.showSuccess = false;
        }, 2000);
        this.$store.dispatch(
          "getNoteAccounting",
          this.$route.params.note_accounting_id
        );
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch(
      "getNoteAccounting",
      this.$route.params.note_accounting_id
    );
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
input,
select {
  height: 45px;
}

.manage-accounting {
  text-align: left;
}

.note-acc-name {
  font-size: 20px;
  text-align: center;
  color: #007afe;
}

.btn-outline {
  p {
    margin: 0;
  }
  padding: 10px 15px;
  background-color: #fff;
  border: 2px solid;
  border-radius: 8px;
  &.primary-btn {
    color: #007afe;
    border-color: #007afe;
  }
  &.danger-btn {
    color: #f74949;
    border-color: #f74949;
  }
}

.form-control {
  width: 100%;
}

.search-box {
  input {
    width: 200px;
    background-color: transparent !important;
    border-radius: 10px;
  }
  img {
    margin: 0 10px;
  }
  background-color: #e0e0e0 !important;
}

.input-arrow {
  user-select: none;
  cursor: pointer;
  min-width: 200px;
  width: 200px;
  height: 45px;
  background-color: #f4f4f4;
  padding: 0.375rem 0.75rem;
  color: #212529;
  border-radius: 0.25rem;
  background-image: url("../../assets/down-arrow-black.svg") !important;
  background-repeat: no-repeat !important;
  background-position: 97% 50% !important;
  padding-right: 40px !important;
}

@media only screen and (min-width: 1440px) {
  .main {
    overflow-x: scroll;
    padding-left: 2rem !important;
    padding-right: 1rem !important;
  }
}

.confirm-button {
  text-align: center;
  display: block;
  color: #fff;
  padding: 10px 15px;
  margin: 30px 10px 10px 10px;
  width: 100%;
  max-width: 130px;
  background: linear-gradient(180deg, #007afe 0%, #013f81 100%);
  border-radius: 10px;
  border: none;

  &-red {
    background: #ed1616;
  }
}

.cancel-button {
  text-align: center;
  display: block;
  color: #fff;
  padding: 10px 15px;
  margin: 30px 10px 10px 10px;
  width: 100%;
  max-width: 130px;
  background: #888;
  border-radius: 10px;
  border: none;
}
.filter {
  border-radius: 10px 10px 10px 10px !important;
  // border: 1px solid #007AFE;
  background: linear-gradient(180deg, #007afe 0%, #013f81 100%);
  margin: 0 !important;

  img {
    width: 40px;
    padding: 0.3rem;
  }
}
.del-icon {
  height: 50px;
  margin-bottom: 15px;
}

input {
  &.form-control {
    border-radius: 0.25rem !important;
  }
}

/*
  Animation
*/
</style>
